import { useEffect } from "react";
import MandevilleHeroSection from "./components/HeroSection";
import MandevilleStickyNav from "./components/StickyNav";
import MandevilleProcessingTimeSection from "./components/ProcessingTimeSection";
import MandevilleServicesSection from "./components/ServicesSection";
import MandevilleLocalAreaSection from "./components/LocalAreaSection";
import MandevilleTestimonialsSection from "./components/TestimonialsSection";
import MandevilleAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import MandevilleComparisonSection from "./components/ComparisonSection";
import MandevilleMistakesSection from "./components/MistakesSection";
import MandevilleHowItWorksSection from "./components/HowItWorksSection";
import MandevilleFAQSection, { faqs } from "./components/FAQSection";
import MandevilleHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import MandevilleFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import MandevilleTravelTimingSection from "./components/TravelTimingSection";
import MandevilleDestinationsSection from "./components/DestinationsSection";

export default function MandevillePage() {
  useEffect(() => {
    document.title = "Emergency Passport Mandeville, LA — Expedited Same-Day Service | Fast Passport Center";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/mandeville/";
    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in Mandeville, LA — as fast as 24 hours. Serving Northshore professionals, lakefront families, and St. Tammany Parish retirees. No Causeway required. A+ BBB rated, registered State Dept. courier.");
    setMeta("geo.placename", "Mandeville, Louisiana");
    setMeta("geo.region", "US-LA");
    setMeta("geo.position", "30.3577;-90.0843");
    setMeta("ICBM", "30.3577, -90.0843");

    const graph = [
      { "@type": "BreadcrumbList", itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" },
        { "@type": "ListItem", position: 2, name: "Louisiana", item: "https://fastpassportcenter.com/louisiana/" },
        { "@type": "ListItem", position: 3, name: "Mandeville Passport Services", item: pageUrl },
      ]},
      { "@type": "LocalBusiness", name: "Fast Passport Center", description: "Emergency and expedited passport services for Mandeville and St. Tammany Parish.", url: pageUrl, telephone: "+1-877-253-0084", areaServed: { "@type": "City", name: "Mandeville", containedInPlace: { "@type": "State", name: "Louisiana" } }, priceRange: "$$$", openingHours: ["Mo-Fr 09:00-18:00"], aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" } },
      { "@type": "FAQPage", mainEntity: faqs.map((faq) => ({ "@type": "Question", name: faq.q, acceptedAnswer: { "@type": "Answer", text: faq.a } })) },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data-mandeville";
    document.getElementById("structured-data-mandeville")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      document.getElementById("structured-data-mandeville")?.remove();
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) canonical.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <MandevilleHeroSection />
      <MandevilleStickyNav />
      <MandevilleProcessingTimeSection />
      <MandevilleServicesSection />
      <MandevilleLocalAreaSection />
      <MandevilleTravelTimingSection />
      <MandevilleDestinationsSection />
      <MandevilleTestimonialsSection />
      <MandevilleAcceptanceFacilitiesSection />
      <MandevilleComparisonSection />
      <MandevilleMistakesSection />
      <MandevilleHowItWorksSection />
      <MandevilleFAQSection />
      <MandevilleHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/mandeville" state="LA" />
      <MandevilleFinalCTA />
    </div>
  );
}